"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTypographyOverrides = void 0;
var createMuiTypographyOverrides = function (theme // eslint-disable-line @typescript-eslint/no-unused-vars
) { return ({
    gutterBottom: {
        marginBottom: "1em",
    },
}); };
exports.createMuiTypographyOverrides = createMuiTypographyOverrides;
//# sourceMappingURL=MuiTypography.js.map